module.exports = __webpack_public_path__ + "static/media/undraw_joyride_hnno.fae6b95e.svg";